import { useEffect, useState } from "react";
import { t } from "i18next";
import { Input } from "@material-tailwind/react";
import Select from "react-select";

interface ServicesFilterFormProps {
    data?: Partial<EasyTech.Service>;
    onChange: (name: string, value: any) => void;
    onSubmit: () => void;
    submitted?: boolean;
}

const ServicesFilterForm = (props: ServicesFilterFormProps) => {
    const [formData, setFormData] = useState<Partial<EasyTech.Service>>(
        props.data || {}
    );

    useEffect(() => {
        setFormData(props.data || {});
    }, [props.data]);

    const handleSelectChange = (value: any, name: string) => {
        const tmp = structuredClone(formData);
        tmp[name as keyof Partial<EasyTech.Service>] = value;
        props.onChange(name, value);
        setFormData(tmp);
    };

    const TYPE_OPTIONS = [
        { value: "SERVICE", label: "Service" },
        { value: "BOOKING_FEES", label: "Booking Fees" },
        { value: "COMBO", label: "Combo" }
    ];

    const getTypeValue = (type: string) => {
        return TYPE_OPTIONS.find(opt => opt.value === type) || null;
    };

    const submit = (e: any) => {
        e.preventDefault();
        props.onSubmit();
    };

    return (
        <form onSubmit={submit} className="grid gap-4 p-2" key={"edit-services-filter"}>
            <div className="grid grid-cols-1 gap-4">
                <div className="field">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t("common:form:fields:label:label")}</label>
                    <Input
                        value={formData.label || ""}
                        onChange={(e) => handleSelectChange(e.target.value, "label")}
                        className="w-full"
                        size="md"
                        placeholder={t("common:form:fields:label:placeholder")}
                        crossOrigin={undefined}
                    />
                </div>

                <div className="field">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t("common:form:fields:ref:label")}</label>
                    <Input
                        value={formData.ref || ""}
                        onChange={(e) => handleSelectChange(e.target.value, "ref")}
                        className="w-full"
                        size="md"
                        placeholder={t("common:ref:placeholder")}
                        crossOrigin={undefined}
                    />
                </div>

                <div className="field">
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t("common:type")}</label>
                    <Select
                        options={TYPE_OPTIONS}
                        value={formData.type ? getTypeValue(formData.type) : null}
                        onChange={(option: any) => handleSelectChange(option ? option.value : null, "type")}
                        placeholder={t("piece:select_type")}
                        isClearable
                    />
                </div>
            </div>
        </form>
    );
};

export default ServicesFilterForm;
